{
  "seo": {
    "title": "Explore Questions",
    "description": "Browse 1,000+ fun questions and answers about science, space, animals, nature, and more. Find answers to everything kids are curious about!",
    "keywords": "explore questions, kids science questions, fun facts, learning for children, curipop"
  },
  "hero": {
    "tagline": "Find your answer!",
    "titlePrefix": "Explore",
    "titleHighlight": "Questions",
    "subtitle": "Every question deserves a great answer!"
  },
  "actions": {
    "surprise": "Surprise Me!",
    "surpriseAria": "Surprise me with a random question",
    "sortAria": "Sort questions"
  },
  "sort": {
    "default": "For You",
    "newest": "Newest",
    "random": "Random"
  },
  "empty": {
    "title": "No questions found",
    "subtitle": "Try adjusting your filters or search query"
  },
  "categories": {
    "science": "Science",
    "history": "History",
    "geography": "Geography",
    "biology": "Biology",
    "technology": "Technology",
    "art": "Art",
    "music": "Music",
    "sports": "Sports"
  }
}
